var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"message-image"},[_c('img',{staticClass:"message-image",attrs:{"mode":"aspectFit","src":_setup.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }